import styled from 'styled-components';

export const Page = styled.div`
  min-height: 100vh;
  background: #f6f8fb;
  font-family: 'Segoe UI', 'Inter', Arial, sans-serif;
`;

export const Container = styled.div`
  max-width: 1240px;
  margin: 0 auto;
  padding: 24px 18px 32px;
`;

export const FlexRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 18px;
`;

export const PageTitle = styled.h2`
  font-size: 1.58rem;
  color: #21325b;
  font-weight: 700;
  margin: 0 0 2px 0;
`;

export const MTDStat = styled.div`
  background: #fff;
  border-radius: 14px;
  padding: 13px 35px 13px 30px;
  box-shadow: 0 4px 20px rgba(35,62,88,0.06);
  font-size: 1.22rem;
  color: #1c2131;
  font-weight: 700;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  min-width: 230px;
  white-space: nowrap;
`;

export const CardRow = styled.div`
  display: flex;
  gap: 18px;
  margin-bottom: 27px;
`;

export const Card = styled.div`
  background: #fff;
  border-radius: 17px;
  box-shadow: 0 1.5px 10px rgba(35,62,88,0.04);
  padding: 1.14rem 2.15rem 1.45rem 1.65rem;
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
`;

export const SectionTitle = styled.div`
  font-size: 1.15rem;
  font-weight: 600;
  color: #21325b;
  margin-bottom: 1rem;
`;

export const InputsRow = styled.div`
  margin-top: 1rem;
  display: flex;
  gap: 18px;
`;

export const Label = styled.label`
  color: #182237;
  font-size: 1rem;
  font-weight: 400;
  margin-bottom: 8px;
  display: block;
`;
export const FilterInputsRow = styled.div`
  display: flex;
  gap: 18px;
  align-items: stretch;
  margin-bottom: 0;
`;

export const FilterInputContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: stretch;
`;

export const FilterInput = styled.input`
  border: 1px solid #eef0fa;
  border-radius: 10px;
  height: 48px;
  font-size: 1.07rem;
  background: #fcfcfe;
  padding: 0 13px;
`;

export const FilterSelect = styled.select`
  border: 1px solid #eef0fa;
  border-radius: 10px;
  height: 48px;
  font-size: 1.07rem;
  background: #fcfcfe;
  padding: 0 13px;
`;

export const ApplyBtn = styled.button`
  height: 48px;
  min-width: 210px;
  background: #426dff;
  color: #fff;
  border-radius: 10px;
  border: none;
  font-size: 1.12rem;
  font-weight: 600;
  align-self: flex-end;
  margin-left: 18px;
  margin-top: 0;
  cursor: pointer;
  box-shadow: 0 1px 4px rgba(35,62,88,0.08);
  &:hover { background: #305de2; }
`;

export const TinyValue = styled.div`
  color: #25b947;
  font-size: 0.97em;
  margin-left: 0.1em;
`;

export const ChartCardGrid = styled.div`
  display: flex;
  gap: 18px;
  margin-top: 12px;
`;

export const StatLabel = styled.div`
  color: #21325b;
  font-size: 1.5rem;
  font-weight: 500;
  margin-bottom: 7px;
`;

export const SubChartLabel = styled.div`
  font-size: 1.11rem;
  font-weight: 500;
  color: #172142;
  margin-bottom: 2px;
  margin-top: 14px;
`;

export const ValueLabel = styled.span`
  color: #21395c;
  font-size: 1.07rem;
  font-weight: 700;
  float: right;
`;

export const TableCard = styled(Card)`
  margin-top: 16px;
  padding: 14px;
`;

export const TableTitle = styled.div`
  font-size: 1.5rem;
  color: #2b3b5f;
  font-weight: 700;
  padding: 22px 0 2px 30px;
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  th, td {
    text-align: left;
    font-size: 1rem;
    font-family: inherit;
    padding: 13px 18px;
    border-bottom: 1px solid #eeeeee;
  }
  th {
    color: #2b3b5f;
    font-weight: 600;
  }
  tr:last-child td {
    border-bottom: none;
  }
`;

export const Badge = styled.span`
  display: inline-block;
  background: #f3f5ff;
  color: #2254da;
  border-radius: 6px;
  font-size: 1.01rem;
  padding: 6px 13px;
  font-weight: 600;
  margin: 0 4px;
`;
